module.exports = __webpack_public_path__ + "img/how-to-get-coin.a15889df.svg";